import { login } from '@/api/login'
import {
  getNewToken,
  getModules,
  setNewToken,
  removeNewToken,
  setModules,
  removeModules
} from '@/utils/auth'
const user = {
  state: {
    token: getNewToken(),
    menuStatus: true,
    modules: getModules(),
    btnpermission: [],
    common: [],
    user: {},
    loginSessionId: '',
    passwordResponse: ''
  },
  mutations: {
    SET_LOGIN_SESSION: (state, loginSessionId) => {
      state.loginSessionId = loginSessionId
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_PASSWORDRESPONSE: (state, passwordResponse) => {
      state.passwordResponse = passwordResponse
    },
    SET_MENU: (state, menuStatus) => {
      state.menuStatus = menuStatus
    },
    MODULES: (state, modules) => {
      state.modules = modules
    },
    PERMISSION: (state, btnpermission) => {
      state.btnpermission = btnpermission
    },
    USER: (state, user) => {
      state.user = user
    },
    COMMON: (state, common) => {
      state.common = common
    }
  },
  actions: {
    loginSessionId ({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_LOGIN_SESSION', data)
      })
    },
    getpasswordResponse ({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_PASSWORDRESPONSE', data)
      })
    },
    menuStatus ({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_MENU', data)
      })
    },
    Login ({ commit, state }, userinfo) {
      return new Promise((resolve, reject) => {
        login(userinfo)
          .then(res => {
            if (res.data.code === 10000) {
              const data = res.data.data
              let menus = []
              if (data.user.userType === 0) {
                menus = [
                  {
                    childMenus: [],
                    menuIcon: 'home',
                    menuId: '1',
                    menuName: '首页',
                    menuOrder: '1',
                    menuUrl: '/index'
                  },
                  {
                    childMenus: [],
                    menuIcon: 'user',
                    menuId: '2',
                    menuName: '律师名片管理',
                    menuOrder: '1',
                    menuUrl: '/user'
                  },
                  {
                    childMenus: [],
                    menuIcon: 'platform',
                    menuId: '3',
                    menuName: '公司简介管理',
                    menuOrder: '1',
                    menuUrl: '/profile'
                  }
                ]
              } else {
                menus = [
                  {
                    childMenus: [],
                    menuIcon: 'home',
                    menuId: '1',
                    menuName: '首页',
                    menuOrder: '1',
                    menuUrl: '/index'
                  },
                  {
                    childMenus: [],
                    menuIcon: 'user',
                    menuId: '2',
                    menuName: '名片信息管理',
                    menuOrder: '1',
                    menuUrl: '/selfUser'
                  }
                ]
              }
              localStorage.setItem('refreshToken', data.refreshToken)
              setNewToken(data.token)
              setModules(JSON.stringify(data.menus))
              commit('SET_MENU', true)
              commit('SET_TOKEN', data.token)
              commit('MODULES', menus)
              // commit('MODULES', menus)
              commit('PERMISSION', [])
              // data.userVo['userCode'] = userinfo.username
              commit('USER', data.user)
              commit('COMMON', data.common)
              // commit('SET_PASSWORDRESPONSE',data.)
              resolve(res)
            } else {
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeNewToken()
        removeModules()
        sessionStorage.clear()
        localStorage.clear()
        resolve()
      })
    }
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js